import Vue from 'vue'
import Vuex from 'vuex'
import address from './modules/address'
import admin from './modules/admin'
import atributos from './modules/atributos'
import carrito from './modules/carrito'
import categories from './modules/categories'
import categoryType from './modules/categoryType'
import client from './modules/client'
import clientes from './modules/clientes'
import colors from './modules/colors'
import copy from './modules/copy'
import coupon from './modules/coupon'
import factura from './modules/factura'
import gallery from './modules/gallery'
import header from './modules/header'
import info from './modules/info'
import label from './modules/label'
import logo from './modules/logo'
import main from './modules/main'
import mainmtr from './modules/mainmtr'
import marcas from './modules/marcas'
import payment from './modules/payment'
import personalizacion from './modules/personalizacion'
import productos from './modules/productos'
import projectInfo from './modules/projectInfo'
import proyectos from './modules/proyectos'
import quotations from './modules/quotations'
import related from './modules/related'
import reviews from './modules/reviews'
import shipment from './modules/shipment'
import slides from './modules/slides'
import sociales from './modules/sociales'
import storeOnline from './modules/storeOnline'
import suscripciones from './modules/suscripciones'
import usuarios from './modules/usuarios'
import wishlist from './modules/wishlist'
import paqueterias from './modules/paqueterias'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    address,
    admin,
    atributos,
    carrito,
    categories,
    categoryType,
    client,
    clientes,
    colors,
    copy,
    coupon,
    factura,
    gallery,
    header,
    info,
    label,
    logo,
    main,
    mainmtr,
    marcas,
    payment,
    personalizacion,
    productos,
    projectInfo,
    proyectos,
    quotations,
    related,
    reviews,
    shipment,
    slides,
    sociales,
    storeOnline,
    suscripciones,
    usuarios,
    wishlist,
    paqueterias
  }
})
